<template>
<div class="wrapper wrapper-content animated fadeInRight">
  <div class="panel-body">
    <div class="ibox-content">
      <div class="form-group">
        <el-collapse  v-model="activeNamesBasis">
          <el-collapse-item title="Notice" name="2">
            <div class="row">
              <div class="col-sm-12">
                <div class="ibox float-e-margins">
                  <div class="ibox-content">
                    <div class="row table-responsive" style="padding-bottom:60px;">
                      <div class="form-group">
                        The following editorial(s) is expired or the event(s)/POI(s) in the editorial/Daily Recommendation is expired or removed, please modify the related editorial and Daily Recommendation.
                      </div>
                      <div class="col-xs-12">{{total1}}{{$t("message.datagridresult") }}</div>
                      <el-table :data="noticeList" style="width: 100%" border ref="multipleTable"  @row-dblclick="handleDbClick1">
                        <el-table-column prop="noticeName" label='Editorial Name' min-width="200" sortable></el-table-column>
                        <el-table-column prop="typeName" label='Issue Type' width="200" sortable></el-table-column>
                        <el-table-column prop="expiredName" label='Event/POI Name' width="350" sortable></el-table-column>
                        <el-table-column prop="expiredDate" label='Expiry Date/Date of Removal' width="300" sortable></el-table-column>
                      </el-table>
                      <el-col :span="24" class="el-table_footertoolbar">
                        <el-pagination 
                           layout="total, sizes, prev, pager, next, jumper" 
                           @size-change="handleSizeChange1" 
                           @current-change="handleCurrentChange1" 
                           :page-sizes="[10, 20, 50, 100]" 
                           :page-size="pagesize1" 
                           :total="total1" 
                           style="float:right;">
                        </el-pagination>
                      </el-col>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-collapse-item>
          <el-collapse-item title="History" name="1">
            <div class="ibox-content m-b-sm border-bottom">
              <div class="row form-horizontal">
                <div class="form-group  margin-0">
                  <label class="col-sm-2 control-label">Module</label>
                  <div class="col-sm-4">
                    <div>
                      <el-select v-model="ocTable" clearable >
                          <el-option 
                          v-for="item in tableObj"
                          :key="item"
                          :label="item"
                          :value="item">
                          </el-option>
                      </el-select>
                    </div>
                  </div>
                  <label class="col-sm-2 control-label">Action</label>
                  <div class="col-sm-4">
                    <div>
                      <el-select v-model="ocAction" clearable >
                          <el-option 
                          v-for="item in actionObj"
                          :key="item"
                          :label="item"
                          :value="item">
                          </el-option>
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="form-group margin-0">
                  <label class="col-sm-2 control-label">
                    Start Date
                  </label>
                  <div class="col-sm-4">
                    <div>
                      <el-date-picker
                        v-model="startDate"
                        type="date"
                        value-format="yyyy-MM-dd 00:00:00"
                        placeholder="startDate">
                      </el-date-picker>
                    </div>
                  </div>
                  <label class="col-sm-2 control-label">
                    End Date
                  </label>
                  <div class="col-sm-4">
                    <div>
                      <el-date-picker
                        v-model="endDate"
                        type="date"
                        value-format="yyyy-MM-dd 00:00:00"
                        placeholder="endDate">
                      </el-date-picker>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="col-sm-12 textRight">
                    <div class>
                      <el-switch
                        v-model="status"
                        @change="turnOnEvent"
                        style="padding-right: 15px"
                        active-text="Turn on Queue-it">
                      </el-switch>
                      <button class="btn btn btn-primary" @click="synchroCrmEvent" style="margin-right:15px">Synchro CRM Event</button>
                      <button class="btn btn btn-primary" @click="search">{{$t("message.Search") }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="ibox float-e-margins">
                  <div class="ibox-content">
                    <div class="row table-responsive" style="padding-bottom:60px;">
                      <div class="col-xs-12">{{total}}{{$t("message.datagridresult") }}</div>
                      <el-table :data="rows" style="width: 100%" border ref="multipleTable" @sort-change="sortChange" @row-dblclick="handleDbClick">
                        <el-table-column prop="ocTable" label='Module' width="200" sortable></el-table-column>
                        <el-table-column prop="ocAction" label='Action' width="120" sortable></el-table-column>
                        <el-table-column prop="dataKey" label='dataKey' width="120" sortable></el-table-column>
                        <el-table-column prop="userName" label='User Name' width="200" sortable></el-table-column>
                        <el-table-column prop="updatedTime" label='Updated Time' width="200" sortable></el-table-column>
                      </el-table>
                      <el-col :span="24" class="el-table_footertoolbar">
                        <el-pagination 
                           layout="total, sizes, prev, pager, next, jumper" 
                           @size-change="handleSizeChange" 
                           @current-change="handleCurrentChange" 
                           :page-sizes="[10, 20, 50, 100]" 
                           :page-size="pagesize" 
                           :total="total" 
                           style="float:right;">
                        </el-pagination>
                      </el-col>
                    </div>
                    <div class="col-sm-12 row" style="margin-top:-30px;">
                      <div class="pull-right">
                        <button
                          class="btn btn-primary"
                          @click="previewEvent"
                         v-if="checkPermission('HOME_PUBLISH')"
                        >{{$t("message.preview") }}</button>
                        <button
                          class="btn btn-primary"
                          @click="publishEvent"
                         v-if="checkPermission('HOME_PUBLISH')"
                        >{{$t("message.Publish") }}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <el-dialog
              title=""
              :visible.sync="showDetail"
              width="90%"
              :append-to-body="true"
              center>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="ibox float-e-margins">
                      <div class="ibox-content">
                        <div class="row table-responsive" style="padding-bottom:60px;">
                          <el-table :data="compareDetail" style="width: 100%" border>
                            <el-table-column prop="key" label='Key' width="300" sortable></el-table-column>
                            <el-table-column prop="befValue" label='Before Value' width="300" sortable></el-table-column>
                            <el-table-column prop="afterValue" label='After Value' width="300" sortable></el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <span slot="footer" class="dialog-footer">
                <el-button @click="cancelEvent">Cancel</el-button>
              </span>
            </el-dialog>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";
import draggable from 'vuedraggable'

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0,//当前页数
      pagesize:10,//一页显示几条
      page1: 0,//当前页数
      pagesize1:10,//一页显示几条
      total:0,
      total1:0,
      rows:[],
      startDate:"",
      endDate:"",
      ocTable:"",
      ocAction:"",
      multipleSelection:[],
      sortType:"DESC",
      sortField:"id",
      showDetail:false,
      compareDetail:[],
      activeName:'first',
      noticeList:[],
      activeNamesBasis:['1','2'],
      tableObj:[],
      actionObj:[],
      status:false,
    };
  },
  created() {

  },
  components: {
    draggable,
  }, 
  methods: {
    async init() {
      this.getNoticeEvent()
      let objdata = this.getAuthObj();
      objdata.sortField = this.sortField;
      objdata.sortType = this.sortType;
      objdata.startRow = this.page;
      objdata.maxRows = this.pagesize;
      objdata.startDate = this.startDate;
      objdata.endDate = this.endDate;
      objdata.ocTable = this.ocTable;
      objdata.ocAction = this.ocAction;
      objdata.apiUrl = '/queryDataCompareList'
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      this.rows = data.data.resultList;
      this.total = data.data.totalRows;
    },
    async getNoticeEvent(){
      let objdata = this.getAuthObj();
      objdata.startRow = this.page1;
      objdata.maxRows = this.pagesize1;
      objdata.apiUrl = '/getNoticeList'
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      data.data.resultList.forEach(item => {
        if(item.type==1){
          item.typeName = "Event Expired"
        }else if(item.type==2){
          item.typeName = "POI Expired"
        }else if(item.type==3){
          item.typeName = "Editorial Expired"
        }else if(item.type==4){
          item.typeName = "Event Expired"
        }
      })
      this.noticeList = data.data.resultList;
      this.total1 = data.data.totalRows;
    },
    turnOnEvent(){
      var _this = this;
      this.$store.commit("setwarning", {
        string: "Are you sure to change? Modification will be effective immediately upon confirmation.",
        boolean: true,
        button: [{
          name:this.$i18n.t("message.Confirm"),
          callBack:function(){
            _this.saveQueueConfigEvent()
          }
        }, {
          name:this.$i18n.t("message.Cancel"),
          callBack:function(){
            _this.status = !_this.status
          }
        }]
      });
    },
    async saveQueueConfigEvent(){
      let objdata = this.getAuthObj();
      objdata.status = this.status;
      objdata.apiUrl = '/saveQueueConfig'
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      this.getQueueConfigEvent();
    },
    async getQueueConfigEvent(){
      let objdata = this.getAuthObj();
      objdata.apiUrl = '/getQueueConfig'
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(!data) return;
      this.status = data.data.result;
    },
    async synchroCrmEvent(){
      let objdata = this.getAuthObj();
      objdata.apiUrl = '/synchroCrmEvent'
      let data = await this.$store.dispatch("apiEvent", objdata);
      if(data){
         this.$toastr.s('Success!');
      }
    },
    async search() {
      this.page = 0;
      this.init();
    },
    handleSizeChange:function(val){
      this.pagesize = val;
      this.init();
    },
    handleCurrentChange:function(val){
      this.page = val-1;
      this.init();
    },
    handleSelectionChange:function(val){
      this.multipleSelection = val;
    },
    async handleDbClick(row){
        let obj = this.getAuthObj();
        obj.dataCompareId = row.id;
        obj.apiUrl = '/getDataCompareDetail'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(data){
           this.compareDetail = data.data.result;
           this.showDetail = true;
        }
    },
    async getTableList(){
        let obj = this.getAuthObj();
        obj.apiUrl = '/getTableList'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(data){
          this.tableObj = data.data.result;
        }
    },
    async getActionList(){
        let obj = this.getAuthObj();
        obj.apiUrl = '/getActionList'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(data){
          this.actionObj = data.data.result;
        }
    },
    async handleDbClick1(row){
        let obj = this.getAuthObj();
        obj.noticeId = row.noticeId;
        obj.type = row.type;
        obj.apiUrl = '/saveNoticeLog'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(row.type==4){
          this.$router.push({
            path: "/main/dailyRecommendation"
          });
        }else{
          this.$router.push({
            path: "/main/editorialDetail",
            query: { 
              id: row.noticeId
            }
          });
        }
    },
    cancelEvent:function(){
        this.compareDetail = [];
        this.showDetail = false;
    },
    sortChange:function(val){
      if(val.order=='ascending'){
        this.sortType = 'ASC';
        this.sortField = val.prop;
      }else if(val.order=="descending"){
        this.sortType = 'DESC';
        this.sortField = val.prop;
      }else{
        this.sortType = 'ASC';
        this.sortField = 'id';
      }
      this.init();
    },
    handleSizeChange1:function(val){
      this.pagesize1 = val;
      this.getNoticeEvent();
    },
    handleCurrentChange1:function(val){
      this.page1 = val-1;
      this.getNoticeEvent();
    },
    handleSelectionChange1:function(val){
      this.multipleSelection = val;
    },
    async previewEvent(){
        let obj = this.getAuthObj();
        obj.apiUrl = '/genWkcdaJson'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(data){
           this.$toastr.s('Success!');
        }
        this.init();
    },
    async publishEvent(){
        let obj = this.getAuthObj();
        obj.apiUrl = '/publishedWkcdaJson'
        let data = await this.$store.dispatch("apiEvent", obj);
        if(data){
           this.$toastr.s('Success!');
        }
        this.init();
    },
  },
  mounted() {
    this.init();
    this.getQueueConfigEvent();
    this.getTableList();
    this.getActionList();
  }
};
</script>
